/**
 * LE PIED DE PAGE — bleu, sur les 28 pages (décision du 2026-09-14).
 *
 * Monté une seule fois, dans `App.js`, sous les routes : le poser dans chaque
 * page recréerait le problème du 2026-09-10, quand il n'était présent que sur
 * 4 pages sur 28.
 *
 * ⚠️ RÉSERVE DE PLACE EN BAS : sur mobile, l'abonné a une barre d'onglets fixée
 * au bas de l'écran. Sans marge, le pied de page se glisse dessous et ses liens
 * deviennent incliquables.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Footer.css';

const LIENS = [
  { to: '/explore', l: 'Bonnes affaires' },
  { to: '/trouver', l: 'Trouvez ma voiture' },
  { to: '/vendre', l: 'Vendre ma voiture' },
  { to: '/contact', l: 'Contact' },
  { to: '/mentions-legales', l: 'Mentions légales' },
  { to: '/confidentialite', l: 'Confidentialité' },
  { to: '/cgu', l: "Conditions d'utilisation" },
  { to: '/cgu-garage', l: 'Conditions garages' },
];

export default function Footer() {
  const { user } = useAuth();
  return (
    <footer className={`zk-pied${user ? ' abonne' : ''}`}>
      <div className="zk-pied-in">
        <p className="zk-pied-marque">
          <b>ZENKART</b> — les voitures vendues sous leur valeur, comparées aux voitures identiques en vente.
        </p>
        <nav aria-label="Pied de page">
          {LIENS.map((x) => <Link key={x.to} to={x.to}>{x.l}</Link>)}
        </nav>
        <p className="zk-pied-copie">© {new Date().getFullYear()} ZENKART</p>
      </div>
    </footer>
  );
}
